export default function ({ store, redirect, app }) {
  if (!store.state.auth.loggedIn) {
    return redirect(app.localePath({ name: 'sign-in' }))
  }

  if (!store.state.auth.user.jobseeker_profile) {
    return redirect(app.localePath({ name: 'index' }))
  }
  if (store.state.auth.user.referrer_profile) {
    return redirect(
      app.localePath({
        name: 'referrer-profile-id',
        params: { id: 'me' },
        query: { tab: 'my-referees' }
      })
    )
  }
}
